import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { FontDeclarations } from '@marketcast/ui-kit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { theme } from './theme';
import { Provider } from 'react-redux';
import { store } from '@/redux';
import { BrowserRouter } from 'react-router-dom';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);


root.render(
  <BrowserRouter>
    <Provider store={store}>
        <ChakraProvider theme={theme}>
          <FontDeclarations />
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ChakraProvider>
    </Provider>
  </BrowserRouter>
);
